import React from 'react';

import { ComponentsRead } from 'src/modules/card/kardComponents/items';
import Gallery from 'src/modules/card/kardComponents/CategoryGallery';

export default
  <>
    <Gallery components={() => <ComponentsRead />} />
  </>;
